import { useTranslation } from "react-i18next";
import { ModifyDetail } from "../../../../redux/apiSpecifications/apiSubjects";
import { useMemo } from "react";

type SubjectDeletedAddressDescriptionDetails = {
  payment_iban: string;
};

interface ISubjectCreatedPaymentMethodDescriptionProps {
  modifyDetailsJson: ModifyDetail[];
}

const SubjectCreatedPaymentMethodDescription = ({
  modifyDetailsJson,
}: ISubjectCreatedPaymentMethodDescriptionProps) => {
  const { t } = useTranslation();

  const subjectAddressDescriptionDetails: SubjectDeletedAddressDescriptionDetails =
    useMemo(() => {
      return {
        payment_iban:
          modifyDetailsJson.find((_) => _.key === "payment_iban")?.value ?? "",
      };
    }, [modifyDetailsJson]);

  return (
    <>
      {t("HISTORY-TEMPLATES.policy-subject-created-payment-method-description", {
        payment_iban: subjectAddressDescriptionDetails.payment_iban,
      })}
    </>
  );
};
export default SubjectCreatedPaymentMethodDescription;
